import RequireRole from "@/components/feature/panel/RequireRole";
import RolePanelShell from "@/components/feature/panel/RolePanelShell";
import { ogretmenConfig } from "@/data/panels";

export default function OgretmenLayout() {
  return (
    <RequireRole role="ogretmen">
      <RolePanelShell {...ogretmenConfig} />
    </RequireRole>
  );
}